import React from "react";
import "./LibrarySubjectCM.css";
import { Tooltip } from "@mui/material";

export default function LibrarySubjectCM(props) {
  function shortenParagraph(text, maxLength) {
    if (text.length <= maxLength) {
      return text;
    }
    return text.slice(0, maxLength).trim() + '...';
  }
  return (
    <div className="d-flex gap-3 toatal_library_container" >
      <img src={props.sublogo} alt="subject logo" className="subicon"></img>
      <div>
        <div className="LibraySubject py-1">
          <Tooltip
            title={props.subname}
            arrow
            placement="top"
            enterDelay={200}
            leaveDelay={100}
          >
            <div>
              {shortenParagraph(props.subname, 20)}
            </div>
          </Tooltip>
        </div>
        <div className="bookList">{props.bookList}</div>
      </div>
    </div>
  );
}
